export enum OnboardingStep {
  Finished = 0,
  Funding = 1,
  Verification = 2,
  Investing = 3
}